import React from 'react';
import PropTypes from 'prop-types';

import { FormattedHTMLMessage } from 'view-components/utilities/intl';

import UpperSectionAlert from 'view-components/components/Dialog/UpperSection/Alert';
import { LowerSectionText } from 'view-components/components/Dialog/Components';

import LowerSectionDeleteConfirm from './Components/LowerSectionDeleteConfirm';
import confirmableDialog from './Components/ConfirmableDialog';
import { DialogProps } from 'global/types';

function LowerContent() {
  return (
    <LowerSectionText>
      <FormattedHTMLMessage
        id="app.dialog.delete_comment.lower_section"
      />
    </LowerSectionText>
  );
}

function DeleteCommentDialogContentFn(props: DialogProps) {
  const {
    isConfirmed = false,
    onConfirm = () => {},
    onDismiss = () => {},
    toggleConfirmed = () => {},
  } = props;

  return (
    <div>
      <UpperSectionAlert>
        <FormattedHTMLMessage
          id="app.dialog.delete_comment.message"
        />
      </UpperSectionAlert>

      <LowerSectionDeleteConfirm
        toggleConfirmed={toggleConfirmed}
        isConfirmed={isConfirmed}
        deleteMessage={
          <FormattedHTMLMessage
            id="app.dialog.delete_comment.confirm_message"
          />
        }
        onConfirm={onConfirm}
        additionalTopContent={<LowerContent />}
        onDismiss={onDismiss}
      />
    </div>
  );
}

DeleteCommentDialogContentFn.propTypes = {
  isConfirmed: PropTypes.bool,
  onConfirm: PropTypes.func,
  onDismiss: PropTypes.func,
  toggleConfirmed: PropTypes.func,
};

const DeleteCommentDialogContent = confirmableDialog(DeleteCommentDialogContentFn);

export default DeleteCommentDialogContent;
